import MentingNftComp from "components/mentingNft";
import React from "react";

const MentingNft = ({getUserNfts}) => {
  return (
    <div>
      <MentingNftComp getUserNfts={getUserNfts} />
    </div>
  );
};

export default MentingNft;
